module.exports = "/_next/static/images/e0e87b68bfd7779a528b492f9d532f56-piecito-desktop.jpg.webp";